import { Routes } from '@angular/router';
import { RouteAccessGuard } from '@app/core/guards/route-access.guard';
import { MerakiAdminAuditComponent } from '@app/features/merakis/modules/meraki-admin-audit/pages/meraki-admin-audit.component';
import { Authority } from '@app/shared/utils/enums';

export const merakiAdminAuditRoutes: Routes = [
    {
        path: 'meraki-admin-audit',
        children: [
            {
                path: '',
                component: MerakiAdminAuditComponent,
                data: {
                    authorities: [Authority.ADMIN, Authority.RESTAURANT_VIEW]
                }
                //,canActivate: [RouteAccessGuard]
            }
        ]
    }
]